import React from "react";
import { useTranslation } from "react-i18next";
import removeFileImg from "../asserts/img/removeFile.svg";
import { useTheme } from "styled-components";
import { IconButton } from "../UI";

export const ExtentionPreview = ({ files, onRemove }) => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px 20px",
      }}
    >
      {files?.map((file, i) => (
        <div
          key={i}
          style={{
            border: `1.4px solid ${theme.color.label}`,
            backgroundColor: theme.color.white,
            color: theme.color.label,
            borderRadius: 20,
            padding: 5,
            fontSize: 16,
            fontWeight: 500,
            display: "inline-flex",
            flexDirection: "row",
            alignItems: "center",
            height: 36,
            width: "33%",
            minWidth: 110,
          }}
        >
          <div
            style={{
              marginInlineEnd: "1em",
              overflow: "hidden",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
              textAlign: "start",
            }}
          >
            {file?.EXTFILEDES}
          </div>
          <IconButton
            src={removeFileImg}
            label={t("remove_file", { name: file?.EXTFILEDES || "" })}
            onClick={() => onRemove(file)}
          />
        </div>
      ))}
    </div>
  );
};

export default ExtentionPreview;
